import $ from 'jquery';
import {initContestCustomFields} from './custom-fields';
import {initWorkContentWysiwyg, initWysiwyg} from './wysiwyg';
import {showFormResponse} from "../common/json-response";
import {deleteCustomColumnVariantHandler}  from '../cabinet/delete-custom-column-variants';
import {showDependsParams} from '../cabinet/show-custom-fields-params';

function addFieldVariantHandler(e) {
  e.preventDefault();
  const fieldUuid   = e.target.getAttribute('data-custom-field-uuid');
  const columnUuid   = e.target.getAttribute('data-custom-column-uuid');
  const fieldFormat = e.target.getAttribute('data-custom-field-format');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const fieldFormatAttr = '[data-custom-field-format="' + fieldFormat + '"]';

  const blockSelector = '.custom_field_params'
    + fieldUuidAttr + fieldFormatAttr
    + ' .custom-columns-variants[data-custom-column-uuid="' + columnUuid + '"]'
  ;
  const columnVariantsBlock = document.querySelector(blockSelector);

  let url = e.target.getAttribute('data-add-url');
  url = url + '?fieldUuid=' + fieldUuid + '&columnUuid=' + columnUuid + '&fieldFormat=' + fieldFormat;
  const statusWrapper = document.querySelector('.action-status-messages');

  $.ajax({
    type: "GET",
    url: url,
    dataType: 'json',
    success: function (data) {
      if (data.messages) {
        showFormResponse(data);
      } else if (data.html) {
        columnVariantsBlock.insertAdjacentHTML('beforeEnd', data.html);
        const newVariantBlock = columnVariantsBlock.querySelector('.custom-columns-variant:last-child');
        const deleteButton = newVariantBlock.querySelector('.delete_custom_column_variant');
        deleteButton.addEventListener('click', deleteCustomColumnVariantHandler);
      }
    },
    error: function (data) {
      if (data.messages) {
        showFormResponse(data);
      } else {
        const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
        const statusMsg = document.createElement('div');
        statusMsg.classList.add(['alert']);
        statusMsg.classList.add(['alert_error']);
        statusMsg.innerHTML = message;
        statusWrapper.appendChild(statusMsg);
      }
    },
  });
}

function initAddNewCustomColumnVariants() {
  const addColumnButtons = document.querySelectorAll('.add_column_variant');
  const statusWrapper = document.querySelector('.action-status-messages');

  addColumnButtons?.forEach(function (button) {
    button.addEventListener('click', addFieldVariantHandler);
  });
}

export {initAddNewCustomColumnVariants, addFieldVariantHandler}